export default __webpack_public_path__ + "static/media/intern.3db86cd1.png";